import partial from 'transmute/partial';
const load = loader => {
  return new Promise((resolve, reject) => {
    loader({
      callback: resolve,
      onerror: reject,
      timeout: 300,
      ontimeout: reject
    });
  });
};
export default (() => {
  const {
    gapi
  } = window;
  if (gapi === undefined) {
    return Promise.resolve({
      isLoaded: false
    });
  }
  const picker = partial(gapi.load, 'picker');
  const client = partial(gapi.load, 'client');
  return Promise.all([load(picker), load(client)]).then(() => gapi.client.load('drive', 'v2')).then(() => ({
    isLoaded: true
  })).catch(() => ({
    isLoaded: false
  }));
});